import { render, staticRenderFns } from "./ProductManual.vue?vue&type=template&id=64bad10e&scoped=true"
import script from "./ProductManual.vue?vue&type=script&lang=js"
export * from "./ProductManual.vue?vue&type=script&lang=js"
import style0 from "./ProductManual.vue?vue&type=style&index=0&id=64bad10e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bad10e",
  null
  
)

export default component.exports